<script lang="ts">
	import { tw } from "../../utils/css/tw";
	import LoadableIcon from "../utility/LoadableIcon.svelte";
	import {
		ButtonSize,
		ButtonVisualStyle,
		getButtonIconStyles,
		getButtonStyles,
		type ButtonProps,
		type ButtonStyleProps,
	} from "./Button";

	const {
		variant,
		size = ButtonSize.Lg,
		visualStyle = ButtonVisualStyle.Filled,
		startIcon: StartIcon,
		endIcon: EndIcon,
		disabled,
		loading = false,
		loadingIconAttrs,
		startIconAttrs,
		endIconAttrs,
		children,
		circle,
		...rest
	}: ButtonProps = $props();

	const styleProps = $derived<ButtonStyleProps>({ variant, size, visualStyle, circle });
	const iconClasses = $derived(tw(getButtonIconStyles(styleProps)));
</script>

<button
	{...rest}
	type={rest.type ?? "button"}
	class={[getButtonStyles(styleProps), rest.class]}
	disabled={disabled ?? loading}
>
	{#if StartIcon !== undefined || (loading && EndIcon === undefined)}
		<LoadableIcon
			class={iconClasses}
			icon={StartIcon}
			{loading}
			loadingAttrs={loadingIconAttrs}
			iconAttrs={startIconAttrs}
		/>
	{/if}
	{@render children?.()}
	{#if EndIcon}
		<LoadableIcon
			class={iconClasses}
			icon={EndIcon}
			loading={loading && StartIcon === undefined}
			loadingAttrs={loadingIconAttrs}
			iconAttrs={endIconAttrs}
		/>
	{/if}
</button>
